// The exact Liquid the proposal-options block serializes to. The server's Liquid
// file system (config/initializers/liquid.rb) resolves "proposal_options" to
// app/views/documents/liquid_snippets/_proposal_options.liquid.
//
// This module is intentionally dependency-free (no Tiptap, no DOM) so it can be
// unit-tested under `node --test` and imported by the Tiptap node extension.
export const PROPOSAL_OPTIONS_INCLUDE = '{% include "proposal_options" %}';

// True when a block of text is exactly the include tag, ignoring surrounding
// whitespace, so a hand-typed include comes back as the atom node on load.
export function isProposalOptionsText(text) {
  return typeof text === "string" && text.trim() === PROPOSAL_OPTIONS_INCLUDE;
}
